import type { ReactNode } from 'react'
import { useMemo, useState } from 'react'
import './filter-tabs.scss'

export interface FilterTab {
  title: string
  view: ReactNode
}

interface FilterTabsProps {
  tabs: Array<FilterTab>
}

const FilterTabs = ({ tabs }: FilterTabsProps) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0]?.title ?? null)

  const activeView = useMemo(() => tabs.find(t => t.title === selectedTab)?.view ?? null, [tabs, selectedTab])

  return (
    <>
      <div className='filter-tabs'>
        {tabs.map(tab => (
          <button
            key={tab.title}
            type='button'
            className='filter-tabs__option'
            onClick={() => setSelectedTab(tab.title)}
            data-selected={tab.title === selectedTab}>
            <span className='filter-tabs__title'>{tab.title}</span>
          </button>
        ))}
      </div>
      {activeView}
    </>
  )
}

export default FilterTabs
